<!-- 柱状图 -->
<template>
    <div class="chart_box" id='chart_box' :style = "{ width: baseConfig.width + 'px', height: baseConfig.height + 'px',left: baseConfig.left + 'px',top: baseConfig.top + 'px'}">
        <div id="main" class="chart" ref='barChartRef' :style = "{ width: baseConfig.width + 'px', height: baseConfig.height + 'px',left: baseConfig.left + 'px',top: baseConfig.top + 'px'}"></div>
    </div>
</template>

<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import * as echarts from 'echarts';
import { useStore } from 'vuex';
export default {
    props: {
        index: {
            type:Number ,
            default: function () { return {} }
        },
        yearRef:{
            type: String,
            default: function () { return "2024" }
        }
    },
    setup(props) {
        const baseConfig = ref({})
        const { proxy } = getCurrentInstance();
        const store = useStore();
        const index = ref(props.index);
        const componentList = ref(computed(() => store.state.chartData.componentList));
        const project = ref(computed(() => store.state.project));
        const option = ref({})
        const danwei=ref()
        const barChartRef = shallowRef(null);
        const chartInstance = shallowRef(null);
        baseConfig.value = componentList.value[index.value].config.baseConfig
        const handleResize = () => {
            chartInstance.value.resize();
        };
        watch(() => store.state.chartData.componentList[index.value].config.options,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
            console.log(newVal,'3333333');
                if(newVal){
                    chartInit()
                }
            },{ deep: true }
        ) 
        watch(() => store.state.chartData.componentList[index.value].config.baseConfig,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
                if(newVal){
                    // console.log(componentList.value[index.value].config.baseConfig,'componentList.value[index.value].config.baseConfig')
                    baseConfig.value = componentList.value[index.value].config.baseConfig
                    // chartInit()
                   setTimeout(()=>{
                    handleResize()
                   })
                    // chart_box = d
                    //
                }
            },{ deep: true }
        ) 
        onMounted(() => {
            chartInstance.value = echarts.init(barChartRef.value);
            // getInfo(props.yearRef)
            chartInit() 
            window.addEventListener('resize', handleResize);
        });
        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });
        const chartInit = ()=>{
            option.value =componentList.value[index.value].config.options;
            let series = componentList.value[index.value].data.echartsData.map((item)=>{
                return {
                    name: item.name,
                    stack: '', 
                    barWidth: 10,  //柱体宽度
                    barCategoryGap:20,
                    // 系列类型，'bar'表示柱状图
                    type: 'bar',
                    // 系列中的数据项，数组中的每个元素对应一个数据值
                    data: item.valueList,
                    barGap: 0.2, //柱体间距
                    showBackground: false,
                    backgroundStyle:{
                        // color:'#fff'
                    },
                    // color: new echarts.graphic.LinearGradient(0, 0,0, 1, [
                    //         { offset: 0, color: '#ff7f50' },
                    //         { offset: 1, color: '#8b0000' }
                    // ]),
                    // 图形样式配置项
                    itemStyle: {
                        // 图形默认样式
                        normal: {
                            barBorderRadius: [0,0,0,0], //圆角大小
                            // 动态设置图形颜色，根据数据项索引从颜色列表中获取颜色
                        }
                    },
                    // 标签配置项
                    label: {
                        // 是否显示标签
                        fontSize: 12,
                        color: "#fff",
                        show: true,
                        fontWeight:'normal', //加粗  //normal默认 //bold 粗体 //bolder特粗体 //lighter 细体 
                        // 标签位置，'top'表示在柱子顶部，其他可选值取决于图表库的实现
                        position: 'top'
                    },
                    // 鼠标悬停时的视觉效果配置项
                    emphasis: {
                        // 鼠标悬停时高亮显示当前系列的所有柱子，'series'表示高亮整个系列，'data'表示高亮单个数据项
                        focus: 'series'
                    }
                }
            })
            option.value.yAxis.data =componentList.value[index.value].data.echartsData[0].nameList
            option.value.xAxis.data =componentList.value[index.value].data.echartsData[0].nameList
            option.value.series = series
            chartInstance.value.setOption(option.value);
        }
    
    // store.commit("setChartData", chartData.value);
    // console.log(chartData.value,'chartData.value')
        return{
            option,
            barChartRef,
            baseConfig,

        }
    }
}
</script>

<style scoped>
.chart_box {position: relative;}
.chart {
    width: 100%;
    height: 100%;
    position: absolute;
}
</style>